import React, { useState, useEffect } from "react";
import { AdmindashboardData,SubAdminsellrecord } from "../../CommonAPI/Admin";
import { AgChartsReact } from "ag-charts-react";

const AdminDashboardChart = ({ userName }) => {

  const [Data1, setData1] = useState({
    loading: true,
    data: [],
  });

  const options = {
    data: Data1 && Data1.data,
    series: [{ type: "bar", xKey: "ServiceStartDate", yKey: "Credit Use" }],
    axes: [
      {
        type: "category",
        position: "bottom",
        title: {
          text: "Service Start Date",
        },
      },
      {
        type: "number",
        position: "left",
        title: {
          text: "Credit Use",
        },
      },
    ],
    zoom: {
      enabled: true,
    },
  };

  const GetDashboardData = async () => {
    await AdmindashboardData()
      .then((response) => {
        if (response.Status) {
          setData1({
            loading: false,
            data: response.Data,
          });
        } else {
          setData1({
            loading: false,
            data: [],
          });
        }
      })
      .catch((err) => {
        console.log("Error in fatching the Dashboard Details", err);
      });
  };

  useEffect(() => {
  if(userName){

    const fetchData = async () => {
      try {
        const response = await SubAdminsellrecord(userName);
        if (response && response.Status) {
          setData1({
            loading: false,
            data: response.Data,
          });
        } else {
            setData1({
            loading: false,
            data: [],
          });
        }
      } catch (error) {
        console.error("Error fetching SubAdminsellrecord:", error);
      }
    };
    fetchData();


  }else{
    GetDashboardData();
  }
  }, [userName]);

  useEffect(() => {
    GetDashboardData();
  }, []);

  return (
    <div className="col-lg-8">
      <div className="iq-card">
        <div className="iq-card-header d-flex justify-content-between">
          <div className="iq-header-title">
            {/* <h3 className="card-title">Earning Per Day</h3> */}
          </div>
        </div>
        <AgChartsReact options={options} />
      </div>
    </div>
  );
};

export default AdminDashboardChart;
